import React, {useState, useContext} from 'react';
import AppContext from 'AppContext';
import { texts, properties, constantesEstadosFasePCT3, tipoFirma } from './FirmaSolicitudData';
import { useHistory } from "react-router-dom";
import {properties as appProperties} from 'AppData';
import RestProvider from 'providers/RestProvider' ;
import useApp from 'AppFunctions';
import { properties as propertiesCloudConfig } from 'config/Config';
import { useSelector, useDispatch } from 'react-redux';
import { insertNewState } from 'redux/slicers/kingdomOV3Slice';

const useFunctions = () => {
    
    const PROPIEDAD_FILE_BASE64 = "base64,";
    const NOMBRE_DOC_SOLICITUD = "Solicitud.pdf";
    const ID_DOC_SOLICITUD = "Solicitud";
    const PREFIJO_OBJETO_FILE_PDF = 'data:application/pdf;base64,';

    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const idExpTrewa = useSelector((state) => state.kingdomOV3.idExpTrewa);
    const fase = useSelector((state) => state.kingdomOV3.fase);
    const estado = useSelector((state) => state.kingdomOV3.estado);
    const faseEstadoExpediente = useSelector((state) => state.kingdomOV3.faseEstadoExpediente);
    const accionModificar = useSelector((state) => state.kingdomOV3.accionModificar);

    const dispatch = useDispatch();

    const context = useContext(AppContext);
    const history = useHistory();
    const {crudOperation, crudOperationsType} = RestProvider();
    const { firmarGenerico, firmaGenericaMasiva, calcularDataSource, calcularHashBase64, obtenerCodigosFaseEstado } = useApp();

    /**
     * @constant isConvocatoriaColaborativa 
     * Evaluando si la convocatoria es colaborativa
     */
    const isConvocatoriaColaborativa = convocatoriaSeleccionada ?  convocatoriaSeleccionada.colaborativa : false;

    
    //Hooks
    const [tituloPagina, setTituloPagina] = useState();
    const [procedimientoActual, setProcedimientoActual] = useState();
    const [NIFUsuario, setNIFUsuario] = useState();
    const [nombreApellidosUsuario, setNombreApellidosUsuario] = useState();
    const [docMarcado, setDocMarcado] = useState(ID_DOC_SOLICITUD);
    const [pdfMostrado, setPdfMostrado] = useState();
    const [isPhoneVersion, setIsPhoneVersion] = useState(false);
    const [mostrarConfirmarFirma, setMostrarConfirmarFirma] = useState(false);
    const [mostrarConfirmarCorregir, setMostrarConfirmarCorregir] = useState(false);
    const [mostrarConfirmarCorregirSubsanacion, setMostrarConfirmarCorregirSubsanacion] = useState(false);
    const [mostrarConfirmarCorregirAlegacion, setMostrarConfirmarCorregirAlegacion] = useState(false);
    const [mostrarErrorPresentacion, setMostrarErrorPresentacion] = useState(false);
    const [msgErrorPresentacion, setMsgErrorPresentacion] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [listDocs, setListDocs] = useState([]);
    const [nombrePdfDescargar, setNombreDescarga] = useState(ID_DOC_SOLICITUD);
    const [isProcessingFirma, setIsProcessingFirma] = useState(false);
    const [solicitudColaborativa, setSolicitudColaborativa] = useState(false);
    const [accionSeleccionada, setAccionSeleccionada] = useState(false);
    const [corregirSolicitud, setCorregirSolicitud] = useState(false);
    const [corregirSubsanacion, setCorregirSubsanacion] = useState(false);
    const [corregirAlegacion, setCorregirAlegacion] = useState(false);
    const [codigoSms, setCodigoSms] = useState(null);
    const [mostrarDialogo, setMostrarDialogo] = useState(false);

    ///Hooks gestion msg errores
    const [message, setMessage] = useState({msg: "", severity: ""});
    let _ID = 0;
    const addAlert = msg => setAlerts([...alerts, { id: _ID++, msg }]);
    const [alerts, setAlerts] = useState([]);
    
    const solicitudActual = useSelector((state) => state.kingdomOV3.solicitudActual);
    const perfilesFirmantes = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada.perfilesFirmantes);
    const procedimiento = useSelector((state) => state.kingdomOV3.procedimientoActual);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);
    const pdfSolicitud = useSelector((state) => state.kingdomOV3.pdfSolicitud);
    const accion = useSelector((state) => state.kingdomOV3.accion);

    //METODOS

    /**
     * @function obtenerAnexosYSolicitud Función que obtiene los anexos y la solicitud
     */
    const obtenerAnexosYSolicitud = async () =>{
        setIsLoading(true);

        //Array que se insertará en la hook listDocs, la cual mostrará la solicitud y los anexos existentes
        let documentos = [];

        //Paso 1. Obtención de la solicitud
        setPdfMostrado(pdfSolicitud);

        //Paso 2. Generación del objeto que contiene la solicitud
        let solicitud = {
            texto: ID_DOC_SOLICITUD,
            nombreArchivo: NOMBRE_DOC_SOLICITUD,
            descripcion: ID_DOC_SOLICITUD,
            id: ID_DOC_SOLICITUD,
            pdf: pdfSolicitud,
            tipoDoc: properties.TIPO_DOC_FORMULARIO
        }

        //Paso 3. Se inserta la solicitud
        documentos.push(solicitud);

        // Obtención de anexos desde PCT2
         if (!procedimiento.fromPct3) {
            //Paso 4. Generación del objeto input que se enviará por parámetros al endPoint obtenerAnexos            
            let input = {
                dataSource: calcularDataSource(procedimiento.codigoAplicacion),
                idSolicitud: solicitudActual.idMoaddSolicitudPdf, 
                idProcedimientos: procedimiento.id,
                nombreFase: fase
            }

            //Paso 5. Obtención de anexos
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_ANEXOS, { url: properties.URL_OBTENER_ANEXOS, method: 'post', data: input }).then(response => {
                //Anexos
                response.data.map((doc, index) => {
                    let anexos = {
                        texto: doc.dsNombre,
                        descripcion: doc.dsDescripcion,
                        id: doc.dsDescripcion,
                        nombreArchivo: doc.tnombreArchivo,
                        pdf: PREFIJO_OBJETO_FILE_PDF + doc.lbDocumento,
                        tipoDoc: doc.cdTipo
                    }
                    //Paso 5.1. Se insertan los anexos obtenidos
                    documentos.push(anexos);
                });
            }).finally(function() {
                //Paso 5.2. Se insertan los documentos obtenidos
                setListDocs(documentos);
                setIsLoading(false);
            });

            // Obtención de anexos desde PCT3
        } else {
            const request = {
                'idExpediente': solicitudActual.id,
                ...faseEstadoExpediente
            }
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DOCUMENTO, { url: properties.URL_OBTENER_ANEXOS_PCT3, method: 'POST', data: request}).then(response => {
                
                for (const doc of response.data) {
                    let anexosObtenidos = {
                        texto: doc.confAnexo.nombre,
                        descripcion: doc.documento.descripcion,
                        id: doc.confAnexo.nombre, //El id debe ser el mismo que el texto para que se marque con el check el radiobutton
                        nombreArchivo: doc.documento.nombre,
                        pdf: PREFIJO_OBJETO_FILE_PDF + doc.fichero,
                        tipoDoc: doc.confAnexo.idTipoDoc,
                        idDoc: doc.documento.id,
                        firmable: doc.confAnexo.firmable
                    }
                    documentos.push(anexosObtenidos);
                }
            }).finally(function() {
                setListDocs(documentos);
                setIsLoading(false);
            });
        }
    }

    /**
     * Obtiene el procedimiento en el que se encuentra para actualizar el
     * titulo de la pagina
     */
     const obtenerTituloPagina = () =>{
        let primeraParte;
        setProcedimientoActual(procedimiento.descripcion);

        let textSolicitud = accionModificar ? texts.PAGE_TITLE_MOD : texts.PAGE_TITLE;;
        let textSubsanacion = accionModificar ? texts.PAGE_TITLE_SUBSANACION_MOD : texts.PAGE_TITLE_SUBSANACION;
        let textAlegacion = accionModificar ? texts.PAGE_TITLE_ALEGACION_MOD : texts.PAGE_TITLE_ALEGACION;
        let textJustificacion = accionModificar ? texts.PAGE_TITLE_JUSTIFICACION_MOD : texts.PAGE_TITLE_JUSTIFICACION;

        switch(fase){
            case properties.FASE_INICIO:
              primeraParte = textSolicitud;
              break;
            case constantesEstadosFasePCT3.F_INICIO_OV3:
              primeraParte = textSolicitud;
              break;
            case properties.FASE_PENDIENTE_DE_SUBSANAR:
              primeraParte = textSubsanacion;
              break;
            case constantesEstadosFasePCT3.F_SUBSANACION_OV3:
              primeraParte = textSubsanacion;
              break;
            case properties.FASE_PDT_ALEGACIONES:
              primeraParte = textAlegacion;
              break;
            case constantesEstadosFasePCT3.F_ALEGACIONES_OV3:
             primeraParte = textAlegacion;
              break;
            case properties.FASE_PENDIENTE_JUSTIFICACION:
              primeraParte = textJustificacion;
              break;
            case constantesEstadosFasePCT3.F_JUSTIFICACION_OV3:
              primeraParte = textJustificacion;
              break;
            default:
              primeraParte = texts.PAGE_TITLE;
              break;
          }
  
        setTituloPagina(primeraParte +  procedimiento.descripcion);
        context.updateTitlePage(primeraParte +  procedimiento.descripcion);
    }

    /**
     * Obtiene el NIF y nombre y apellidos del usuario logeado
     */
     const obtenerDatosUsuario = () =>{
        let nombreApellidos = infoUsuario.interesadoNombre + texts.ESPACIO + infoUsuario.interesadoApellido1 + texts.ESPACIO + infoUsuario.interesadoApellido2;
        setNIFUsuario(infoUsuario.interesadoNif);
        setNombreApellidosUsuario(nombreApellidos);

    }

    //Metodo que te lleva al paso anterior, en este caso a Aporte Documentacion
    const atrasFormulario = () => {
        let redireccion = (perfilSeleccionado.descripcion === 'REPRESENTANTE_SICA' && solicitudColaborativa)
            ? properties.URL_NUEVA_SOLICITUD
            : properties.URL_APORTE_DOCUMENTACION;
        
        history.push(redireccion);
    };

    //Metodo para el cambio de valor de los radioButtons
    const handleChange = (e, newValue) => {
        let docMarcado = e.target.id;
        setDocMarcado(docMarcado);
        for (let doc of listDocs) {
            if (doc.id.toString() === docMarcado.toString()) { 
                setPdfMostrado(doc.pdf)
                setNombreDescarga(doc.nombreArchivo)
            }
        }
    };

    /**
     * @function updateFormat Segun el num de pixeles del ancho de la pantalla pone version movil o version ordenador
     */
     const updateFormat = () => {
        if(window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
            setIsPhoneVersion(true);
        } else {
            setIsPhoneVersion(false);
        }
    }

    //Metodo para mostrar el confirmar
    const mostrarConfirmacion = () => {
        setMostrarConfirmarFirma(true);
    }

    //Metodo para dejar de motrar el componente confirmar
    const dejarDeMostrarConfirmacion = () => {
        setMostrarConfirmarFirma(false);
    }

    //Metodo para mostrar el corregir confirmar
    const mostrarConfirmacionCorregir = () => {
        setMostrarConfirmarCorregir(true);
        setCorregirSolicitud(true);
    }

    //Metodo para mostrar el corregir confirmar subsanacion
    const mostrarConfirmacionCorregirSubsanacion = () => {
        setMostrarConfirmarCorregirSubsanacion(true);
        setCorregirSubsanacion(true);
    }

    //Metodo para mostrar el corregir confirmar alegacion
    const mostrarConfirmacionCorregirAlegacion = () => {
        setMostrarConfirmarCorregirAlegacion(true);
        setCorregirAlegacion(true);
    }

    //Metodo para dejar de motrar el componente confirmar
    const dejarDeMostrarConfirmacionCorregir = () => {
        setMostrarConfirmarCorregir(false);
        setCorregirSolicitud(false);
    }
    //Metodo para dejar de motrar el componente confirmar subsanacion
    const dejarDeMostrarConfirmacionCorregirSubsanacion = () => {
        setMostrarConfirmarCorregirSubsanacion(false);
        setCorregirSubsanacion(false);
    }

    //Metodo para dejar de motrar el componente confirmar alegacion
    const dejarDeMostrarConfirmacionCorregirAlegacion = () => {
        setMostrarConfirmarCorregirAlegacion(false);
        setCorregirAlegacion(false);
    }

    //AUTOFIRMA
    const firmarSolicitud = () => {
        dejarDeMostrarConfirmacion();
        dejarDeMostrarConfirmacionCorregir();

        if(!procedimiento.fromPct3){
            firmarGenerico(listDocs[0].pdf, presentarSolicitud, null, 'PCT2');
        }else{
            let listDocumentos = [];
            listDocs.forEach(doc => {
                if(doc.tipoDoc===properties.TIPO_DOC_FORMULARIO || doc.firmable){
                    doc.esFirmable = true;
                    listDocumentos.push(doc.pdf);
                }else{
                    doc.esFirmable = false;
                }
            });
            let tpFirma = obtenerTipoFirma();
            if ((solicitudColaborativa && (perfilSeleccionado.descripcion === 'INVESTIGADOR'|| perfilSeleccionado.descripcion === 'GESTOR')) || (tpFirma === tipoFirma.FIRMA_SMS)) {
                presentarSolicitudPct3(null);
            }else{
                firmaGenericaMasiva(listDocumentos, presentarSolicitudPct3, null, 'PCT3');
            }
            
        }     
    }

    const firmarCorregirSolicitud = async () => {
        dejarDeMostrarConfirmacion();
        dejarDeMostrarConfirmacionCorregir();

        if(!procedimiento.fromPct3){
            firmarGenerico(listDocs[0].pdf, presentarSolicitud, null, 'PCT2');
        }else{
            let listDocumentos = [];
            listDocs.forEach(doc => {
                if(doc.tipoDoc===properties.TIPO_DOC_FORMULARIO || doc.firmable){
                    doc.esFirmable = true;
                    listDocumentos.push(doc.pdf);
                }else{
                    doc.esFirmable = false;
                }
            });
            presentarSolicitudPct3(null);
        }     
    }

    //PRESENTAR SOLICITUD
    const presentarSolicitud = (signatureBase64, certificate864) => {
        let inputPresentarSolicitud =  montarInputPresentarSolicitud(signatureBase64);
        setIsLoading(true);
        setIsProcessingFirma(true);
        
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PRESENTAR_SOLICITUD, {url:properties.URL_PRESENTAR_SOLICITUD, method: 'post', data:inputPresentarSolicitud}).then(response => {       
            
            dispatch(insertNewState({filnedName: 'recibi', value: response.data.recibi}));
            dispatch(insertNewState({filnedName: 'numRegistroAries', value: response.data.numRegistroAries}));
            dispatch(insertNewState({filnedName: 'idExpTrewa', value: response.data.idTrewa}));

            setIsLoading(false);
            history.push(properties.URL_SOLICITUD_PRESENTADA);  

        }).catch(function (error) {
            setIsLoading(false);
            if(error.response){
                let msg = "Se ha producido un error genérico.";     
                setMsgErrorPresentacion(msg + texts.PARTE_2_MSG_ERROR);
            }else{
                setMsgErrorPresentacion(texts.PARTE_1_MSG_ERROR + texts.PARTE_2_MSG_ERROR); 
            }   
            
            setMostrarErrorPresentacion(true);
        })
    }

    //PRESENTAR SOLICITUD PCT3
      const presentarSolicitudPct3 = (signatureBase64, certificate864) => {
        let inputPresentarSolicitudPct3 =  montarInputPresentarSolicitudPct3(signatureBase64);
        setIsLoading(true);
        setIsProcessingFirma(true);
        let ruta = null;

        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_PRESENTAR_SOLICITUD_PCT3, {url:'', method: 'post', data:inputPresentarSolicitudPct3}).then(response => {       
            if (!solicitudColaborativa || response.data.tieneRecibi === true) {
                dispatch(insertNewState({filnedName: 'recibi', value: response.data.recibi}));
                dispatch(insertNewState({filnedName: 'numRegistroAries', value: response.data.numRegistroAries}));
                dispatch(insertNewState({filnedName: 'numeroExpediente', value: response.data.numeroExpediente}));
                dispatch(insertNewState({filnedName: 'idExpediente', value: response.data.idExpediente}));
                ruta = properties.URL_SOLICITUD_PRESENTADA;
            } else {
                ruta = properties.URL_BANDEJA_SOLICITUDES;
            }

            setIsLoading(false);
            history.push(ruta);  

        }).catch(function (error) {
            setIsLoading(false);
            if(error.response){
                let msg = "Se ha producido un error genérico.";
                setMsgErrorPresentacion(msg + texts.PARTE_2_MSG_ERROR);
            }else{
                setMsgErrorPresentacion(texts.PARTE_1_MSG_ERROR + texts.PARTE_2_MSG_ERROR); 
            }   
            
            setMostrarErrorPresentacion(true);
        })
    }

    const dejarDeMostrarErrorPresentacion = () => {
        setMostrarErrorPresentacion(false);
    }

    const obtenerTipoDocumento = (tipoDocumento) => {
        let response = null;

        if(tipoDocumento==="AOB"){
            response = properties.TIPO_DOC_OBLIGATORIO
        }else if(tipoDocumento==="AOP"){
            response = properties.TIPO_DOC_OPTATIVO
        }else if(tipoDocumento==="AUS"){
            response = properties.TIPO_DOC_VOLUNTARIO
        }
        return response;
    }

    const montarDocumentosEntrega = (firma) => {
        let arrayDocumentoEntrega = new Array(listDocs.length);
        let documentoEntrega;

        listDocs.map((doc, index)=>{
            if(doc.tipoDoc===properties.TIPO_DOC_FORMULARIO){
                documentoEntrega = {
                    firmaBase64: firma,
                    hashDocumentoBase64: calcularHashBase64(listDocs[index].pdf),
                    documento: doc.pdf.split(PROPIEDAD_FILE_BASE64)[1],
                    nombreDocumento: doc.texto,
                    tipoDocumento: properties.TIPO_DOC_FORMULARIO,
                    descripcionDocumento: doc.descripcion
                }
                
            }else{
                documentoEntrega = {
                    firmaBase64: null,
                    hashDocumentoBase64: null,
                    documento: doc.pdf.split(PROPIEDAD_FILE_BASE64)[1],
                    nombreDocumento: doc.texto,
                    tipoDocumento: obtenerTipoDocumento(doc.tipoDoc),
                    descripcionDocumento: doc.descripcion
                }
            }
            arrayDocumentoEntrega[index] = documentoEntrega;
        });
        return  arrayDocumentoEntrega;
    }

    const montarInputPresentarSolicitud = (firma) => {
        if (fase === properties.FASE_PENDIENTE_DE_SUBSANAR || fase === properties.FASE_PDT_ALEGACIONES 
            || fase === properties.FASE_PENDIENTE_JUSTIFICACION) {
        }

        let procEnumEntrega = null;
        let idExpTrewaSub = null;

        if(fase === properties.FASE_PENDIENTE_DE_SUBSANAR){
            procEnumEntrega = properties.PROCESO_ENTREGA_SUBSANACION;
            idExpTrewaSub = idExpTrewa;
        } else if(fase === properties.FASE_PDT_ALEGACIONES){
            procEnumEntrega = properties.PROCESO_ENTREGA_ALEGACION;
            idExpTrewaSub = idExpTrewa;
        } else if(fase === properties.FASE_INICIO){
            procEnumEntrega = properties.PROCESO_ENTREGA_SOLICITUD;
        } else if(fase === properties.FASE_PENDIENTE_JUSTIFICACION){
            procEnumEntrega = properties.PROCESO_ENTREGA_JUSTIFICACION;
            idExpTrewaSub = idExpTrewa;
        }

        let inputPresentarSolicitud = {
            dataSource: calcularDataSource(procedimiento.codigoAplicacion),
            dniLogin: infoUsuario.interesadoNif,
            numeroSerieCertificadoLogin: infoUsuario.datosCertificado ? infoUsuario.datosCertificado.numeroSerie : null ,
            isloginCertificadoDigital: infoUsuario.tipoAutenticacion === appProperties.TIPO_AUTENTICACION_CERTIFICADO ? true : false,
            listadoDocumentosEntregaDTO: montarDocumentosEntrega(firma),
            organismo:"A01004509", //TODO
            idProcedimiento: procedimiento.id,
            cdProcTrewa: convocatoriaSeleccionada.cdProcTrewa,
            descripcionProcedimiento: procedimiento.descripcion,
            descripcionConvocatoria: convocatoriaSeleccionada.descripcion,
            codigoSistemaTrewa: procedimiento.cdSistemaTrewa,
            usuarioTrewa: perfilSeleccionado.cdUsuarioTrewa,
            tipoExpedienteTrewa: convocatoriaSeleccionada.cdTipoExpTrewa,
            // Eliminamos la información de la zona horaria recibida
            fechaInicioPresentacion: convocatoriaSeleccionada.fechaInicioPresentacion.substring(0, 23)+"+00:00",
            fechaFinPresentacion: convocatoriaSeleccionada.fechaFinPresentacion.substring(0, 23)+"+00:00",
            enumProcesoEntrega: procEnumEntrega,
            idMoaddSolicitudesPDF: solicitudActual.idMoaddSolicitudPdf,
            idAplicacion: procedimiento.codigoAplicacion,
            idExpTrewaSubsanacion: idExpTrewaSub,
        }
        
        return inputPresentarSolicitud;
    }

    const montarInputPresentarSolicitudPct3 = (firma) => {
        let enumeradoProcesoEntrega = null;

        // Obtención de enumProcesoEntrega
        if (fase !== undefined && fase !== null && fase !== '') {
            // Solicitudes que pertenezcan a proyectos colaborativos en fase origen INICIO
            if (solicitudColaborativa) {
                switch (perfilSeleccionado.descripcion) {
                    case 'PROYECTO_COLECTIVO': 
                        if (accionSeleccionada === 'subsanar' && fase == constantesEstadosFasePCT3.F_SUBSANACION_OV3) {
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_COD_SUBSANACION_SEQUIA;
                        } else if (accionSeleccionada === 'subsanarAltaAnexo') {
                           enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_COD_SUBSANACION_ALTA_ANEXO;
                        } else {
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_ANEXO_A_LA_SOLICITUD;
                        }
                        break;
                    case 'INVESTIGADOR':
                    case 'GESTOR': 
                        if(accionSeleccionada === 'subsanar' || accionSeleccionada === 'corregirSubsanacion'){
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_SOLICITAR_REVISION_SUBSANACION;
                        }else if(accionSeleccionada === 'alegar' || accionSeleccionada === 'corregirAlegacion'){
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_SOLICITAR_REVISION_ALEGACION;
                        }else {
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_SOLICITAR_REVISION;
                        }
                        break;
                    case 'REPRESENTANTE_SICA': 
                        if(corregirSolicitud === false && corregirSubsanacion === false && corregirSubsanacion === false && fase === constantesEstadosFasePCT3.F_SUBSANACION_OV3){
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_FIRMAR_SUBSANACION_SICA;
                        } else if(corregirSolicitud === false && corregirAlegacion === false && fase === constantesEstadosFasePCT3.F_ALEGACIONES_OV3){
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_FIRMAR_ALEGACION_SICA;
                        } else if(corregirSolicitud){
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_CORREGIR_SOLICITUD;
                        }else if(corregirSubsanacion){
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_CORREGIR_SUBSANACION;
                        }else if(corregirAlegacion){
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_CORREGIR_ALEGACION;
                        }else if(corregirSolicitud === false){
                            enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_FIRMAR_SOLICITUD_SICA;
                        }
                        break;
                }                   
            } else {
                switch (fase) {
                    case constantesEstadosFasePCT3.F_ALEGACIONES_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_ALEGACION;
                        break;
                    case constantesEstadosFasePCT3.F_APORTE_DOCUMENTACION_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_APORTE_DOCUMENTACION;
                        break;
                    case constantesEstadosFasePCT3.F_JUSTIFICACION_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_JUSTIFICACION;
                        break;
                    case constantesEstadosFasePCT3.F_SUBSANACION_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_SUBSANACION;
                        break;
                    case constantesEstadosFasePCT3.F_INICIO_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_SOLICITUD;
                        break;
                    case constantesEstadosFasePCT3.F_ALTA_MOD_RADA_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_COD_ALT_MOD_RADA; //provisionalmente
                        break;
                    case constantesEstadosFasePCT3.F_MOD_OFICIO_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_ALEGACION;
                        break;
                    case constantesEstadosFasePCT3.F_RENOV_RADA_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_RENOVACION_RADA;
                        break;
                    case constantesEstadosFasePCT3.F_RADA_CAN_OFI_OV3: enumeradoProcesoEntrega = properties.PROCESO_ENTREGA_ALEGACION;
                        break;
                }
            }
        }

        let inputPresentarSolicitud = {
            enumProcesoEntrega: enumeradoProcesoEntrega,
            idExpediente: solicitudActual.id === undefined ? solicitudActual.idExpediente : solicitudActual.id, 
            numeroExpediente: solicitudActual.numeroExpediente,
            idConvocatoria:convocatoriaSeleccionada.id,
            dniLogin: infoUsuario.interesadoNif,
            numeroSerieCertificadoLogin: infoUsuario.datosCertificado ? infoUsuario.datosCertificado.numeroSerie : null ,
            isloginCertificadoDigital:infoUsuario.tipoAutenticacion === appProperties.TIPO_AUTENTICACION_CERTIFICADO ? true : false,
            descripcionConvocatoria: convocatoriaSeleccionada.descripcion,
            // Eliminamos la información de la zona horaria recibida
            fechaInicioPresentacion:convocatoriaSeleccionada.fechaInicioPresentacion.substring(0, 23)+"+00:00",
            fechaFinPresentacion: convocatoriaSeleccionada.fechaFinPresentacion.substring(0, 23)+"+00:00",
            idProcedimiento: procedimiento.id,
            descripcionProcedimiento: procedimiento.descripcion,
            usuarioAries: convocatoriaSeleccionada.codAriesUsuario,
            passwordAries:convocatoriaSeleccionada.codAriesPassword,
            asuntoAries: convocatoriaSeleccionada.codAriesAsunto,
            destinatarioAries: convocatoriaSeleccionada.codAriesDestinatario,
            listDocumentos: montarDocumentosEntregaPct3(firma), //TODO
            fase: fase,
            estado: estado,
            perfil: perfilSeleccionado,
            enumTipoFirma: obtenerTipoFirma()
        }
        
        return inputPresentarSolicitud;
    }

    /**
     * @function obtenerTipoFirma Función que encargada de obtener el tipo de firma que se realizará en el proceso de entrega
     */
    const obtenerTipoFirma = () => {
        let res = tipoFirma.FIRMA_SIMPLE;
        if  (infoUsuario.tipoAutenticacion !== undefined && infoUsuario.tipoAutenticacion !== '') {
            res = ((convocatoriaSeleccionada.firmaSms !== undefined && convocatoriaSeleccionada.firmaSms !== '' && convocatoriaSeleccionada.firmaSms) 
            && infoUsuario.tipoAutenticacion === 'ur') ? tipoFirma.FIRMA_SMS : tipoFirma.FIRMA_SIMPLE;
        }

        return res;
    }

    const obtenerBase64Puro = (contenido) => {
        if (!contenido || typeof contenido !== 'string') return null;

        const indice = contenido.indexOf(PROPIEDAD_FILE_BASE64);
        const base64 = indice !== -1 ? contenido.split(PROPIEDAD_FILE_BASE64)[1] : contenido;

        // Si es undefined como string o vacío, lo descartamos
        if (!base64 || base64.trim() === '' || base64 === 'undefined') return null;

        return base64;
    };

    const montarDocumentosEntregaPct3 = (firma) => {
        let arrayDocumentoEntrega = new Array(listDocs.length);
        let firmas = firma !== null ? firma.split(':') : null;
        let indexFirmas = 0;

        listDocs.forEach((doc, index) => {
            const pdf = doc.pdf;
            const contenidoBase64 = obtenerBase64Puro(pdf);
            const hash = contenidoBase64 ? calcularHashBase64(pdf) : null;

            let firmaDoc = null;
            if (doc.tipoDoc === properties.TIPO_DOC_FORMULARIO || doc.esFirmable) {
                firmaDoc = firmas !== null ? firmas[indexFirmas] : null;
                indexFirmas++;
            }

            const documentoEntrega = {
                firmaBase64: firmaDoc,
                hashDocumentoBase64: hash,
                documento: contenidoBase64,
                nombreDocumento: doc.texto,
                tipoDocumento: doc.tipoDoc === properties.TIPO_DOC_FORMULARIO
                    ? properties.TIPO_DOC_FORMULARIO
                    : properties.TIPO_DOC_ANEXO,
                descripcionDocumento: doc.descripcion,
                idDoc: doc.idDoc,
                firmado: doc.tipoDoc === properties.TIPO_DOC_FORMULARIO || doc.esFirmable
            };

            arrayDocumentoEntrega[index] = documentoEntrega;
        });

        return arrayDocumentoEntrega;
    };

    const calcularSiEsFirmable = async (doc) => {
  
        return doc.Firmable;
    }

    /**
     * @function obtenerFasesEstados Función que obtiene los códigos de las fases y los estados buscados
     * @returns 
     */
    const obtenerFasesEstados = async () => {
        let constantes = [];

        // Paso 1. Obtiene las constantes decalradas en BandejaSolicitudesData y se insertan en el array cosntates.
        for (const key in constantesEstadosFasePCT3) {
            constantes.push(key);
        }

        // Paso 2. Se obtienen las fases y estados 
        let fasesEstadosObtenidos = await obtenerCodigosFaseEstado(convocatoriaSeleccionada.id, constantes, constantes);        
        
        // Paso 3. Se recorren los valores obtenidos y se insertan en las constantes que se utilizaran en la pantalla
        for (const feo of fasesEstadosObtenidos.valores) {

            switch (feo.clave) {
                case 'EF_INICIADO_OV3':
                    constantesEstadosFasePCT3.EF_INICIADO_OV3 = feo.valor;
                    break;
                case 'EF_PENDIENTE_ALEGACION_OV3':
                    constantesEstadosFasePCT3.EF_PENDIENTE_ALEGACION_OV3 = feo.valor;
                    break;
                case 'EF_PENDIENTE_SUBSANAR_OV3':
                    constantesEstadosFasePCT3.EF_PENDIENTE_SUBSANAR_OV3 = feo.valor;
                    break;
                case 'F_INICIO_OV3':
                    constantesEstadosFasePCT3.F_INICIO_OV3 = feo.valor;
                    break;
                case 'F_ALEGACIONES_OV3':
                    constantesEstadosFasePCT3.F_ALEGACIONES_OV3 = feo.valor;
                    break;
                case 'F_SUBSANACION_OV3':
                    constantesEstadosFasePCT3.F_SUBSANACION_OV3 = feo.valor;
                    break;
                case 'F_ALTA_MOD_RADA_OV3':
                    constantesEstadosFasePCT3.F_ALTA_MOD_RADA_OV3 = feo.valor;
                    break;
                case 'F_MOD_OFICIO_OV3':
                    constantesEstadosFasePCT3.F_MOD_OFICIO_OV3 = feo.valor;
                    break;
                case 'F_RENOV_RADA_OV3':
                    constantesEstadosFasePCT3.F_RENOV_RADA_OV3 = feo.valor;
                    break;
                case 'F_RADA_CAN_OFI_OV3':
                    constantesEstadosFasePCT3.F_RADA_CAN_OFI_OV3 = feo.valor;
                    break;
                default:
                    break;
            }
        }
    }

    /**
     * @function isSolicitudColaborativa Función que comprueba si se trata de una solicitud que pertenezca a un proyecto colaborativo.
     * Para que sea una solicitud colaborativa, la convocatoria debe ser colaborativa y además cuando se ha accedido a la convocatoria,
     * se ha seleccionado el perfil colaborativo.
     */
    const isSolicitudColaborativa = async () => {
        // Paso 1. Se obtienen las convocatorias y los perfiles colaborativos
        let perfilesColaborativos = propertiesCloudConfig['PERFILES_COLABORATIVOS_CODIGO'];

        // Paso 2. Se genera el array de cada uno
        let perfilesObtenidos = perfilesColaborativos !== undefined ? perfilesColaborativos.split(', ') : null;

        // Paso 3. Se evalúa si la convocatoria actual y el perfil seleccionado pertenecen a convocatorias y perfiles colaborativos
        if (perfilesObtenidos !== null && isConvocatoriaColaborativa !==  null) {
            let isPerfilColaborativo = perfilesObtenidos.includes(perfilSeleccionado.descripcion);
            setSolicitudColaborativa(isPerfilColaborativo && isConvocatoriaColaborativa);
            setAccionSeleccionada(accion);
        }
    }

    /**
     * @function isFirmante Función encargada de obtener si el perfil seleccioado es uno de los perfiles que pueden firmar,
     */
    const isFirmante = () => {
        console.log(solicitudColaborativa);
        const existePerfil = perfilesFirmantes.some(perfil => perfil.codigo === perfilSeleccionado.codigo);
        return existePerfil;
    }

    /**
     * @function handleSetMessage Gestiona los mensajes de por pantalla para errores, info, etc
     */
    const handleSetMessage = (msg, severity) => {
        setMessage({msg, severity});
        addAlert(message);
    }

    /**
     * @function handleShowDialogo Función encargada de mostrar el cuadro de diálogo
     */
    const handleShowDialogo = () => {
        setMostrarDialogo(true);
    }

    /**
     * @function handleHideDialogo Función encargada de ocultar el cuadro de diálogo
     */
    const handleHideDialogo = () => {
        setCodigoSms('');
        setMostrarDialogo(false);
    }

    /**
     * @function enviarCodigoSms Función encargada de enviar el código sms al ciudadano
     */
    const enviarCodigoSms = async () => {
        let tlfMovil = null;
        let res = null;

        // Paso 1. Obtención del número de teléfono móvil del usuario logado
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_DATOS_CONTACTO, { url: properties.URL_TLF_MOVIL + infoUsuario.interesadoNif, method: 'get' }).then(response => {
            tlfMovil = response.data;
        }).catch(function (error) {
            setMsgErrorPresentacion(error.response.data);
        });
        // Paso 2. Si se obtiene el número de teléfono móvil, se procede a enviar el código sms al ciudadano
        if (tlfMovil != null) {

            // Paso 2.1. Generación del DTO necesario para el endPoint de envío de sms
            let input = {
                idExpediente: solicitudActual.id === undefined ? solicitudActual.idExpediente : solicitudActual.id,
                nombre: infoUsuario.interesadoNombre,
                apellido1: infoUsuario.interesadoApellido1,
                apellido2: infoUsuario.interesadoApellido2,
                nifNiePasaporte: infoUsuario.interesadoNif,	
                destino: tlfMovil
            }
            
            // Paso 2.2. Envío del código sms al ciudadano
            await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SMS, { url: properties.URL_ENVIAR_SMS, method: 'post', data: input }).then(response => {
                res = response.data; 
                handleShowDialogo();
            }).catch(function (error) {
                handleSetMessage('Se ha producido un error durante el envío del sms', "error");
            });
        }
        return res;
    }

    const handleChangeDialogo = (e) => {
        setCodigoSms(e.target.value);
    }

    /**
     * @function validarCodigoSms Función que evalúa si el código sms que ha insertado el usuario es el que ha recibido,
     * si es correcto realiza la presentación del expediente utilizando la firma sms
     * @param {*} e 
     * @returns 
     */
    const validarCodigoSms = async () => {
        let res = null;
        let idExp = solicitudActual.id === undefined ? solicitudActual.idExpediente : solicitudActual.id;

        // Comprobación del código insertado
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_SMS, { url: properties.URL_COMPROBAR_CODIGO + codigoSms + `/${idExp}`, method: 'get'}).then(response => {
            // Paso 1. Se obtiene el objeto de respuesta
            res = response.data;

            // Paso 2. Se oculta el cuadro de diálogo
            handleHideDialogo();

            // Paso 3. Se procede a realizar el proceso de firma
            firmarSolicitud();
        }).catch(function (error) {
            let msg = `El código ${codigoSms} es erróneo para esta solicitud`;
            let codError = 'error';
            handleSetMessage(msg, codError);
        });

        return res;
    }

    /**
     * @function mostrarBtnFirmaCertOrClave Función que devuelve un valor booleando indicando.
     * Comprueba si el usuario se ha logado con certificado digital o con clave además, de si se trata de una solicitud colaborativa
     * @returns 
     */
    const mostrarBtnFirmaCertOrClave = () => {
        let res = false;

        if  (infoUsuario.tipoAutenticacion !== undefined && infoUsuario.tipoAutenticacion !== '') {
            res = ((infoUsuario.tipoAutenticacion === 'cd' || infoUsuario.tipoAutenticacion === 'cl') && solicitudColaborativa === false && isFirmante());
        }

        return res;
    }

    return { obtenerTituloPagina, tituloPagina, procedimientoActual, obtenerDatosUsuario, NIFUsuario, nombreApellidosUsuario, 
        atrasFormulario, handleChange, docMarcado, listDocs, isPhoneVersion, updateFormat, pdfMostrado, mostrarConfirmarFirma, mostrarConfirmarCorregir, mostrarConfirmarCorregirSubsanacion, mostrarConfirmarCorregirAlegacion,
        mostrarConfirmacion, mostrarConfirmacionCorregir, mostrarConfirmacionCorregirSubsanacion, mostrarConfirmacionCorregirAlegacion, dejarDeMostrarConfirmacion, dejarDeMostrarConfirmacionCorregir, dejarDeMostrarConfirmacionCorregirSubsanacion, dejarDeMostrarConfirmacionCorregirAlegacion, firmarCorregirSolicitud, mostrarErrorPresentacion, dejarDeMostrarErrorPresentacion,
        msgErrorPresentacion, isLoading, obtenerAnexosYSolicitud, nombrePdfDescargar, isProcessingFirma, presentarSolicitudPct3,
        obtenerFasesEstados, solicitudColaborativa, isSolicitudColaborativa, perfilSeleccionado, perfilesFirmantes, isFirmante, accionSeleccionada, validarCodigoSms, codigoSms, handleShowDialogo, handleHideDialogo, mostrarDialogo, enviarCodigoSms, handleChangeDialogo,
        obtenerTipoFirma, message, setMessage, alerts, mostrarBtnFirmaCertOrClave, setMsgErrorPresentacion, firmarSolicitud
    };
}
export default useFunctions;